import ISlaDetails from "interfaces/ISlaDetails";
import ISlaDetailsViewModel from "interfaces/ISlaDetailsViewModel";

const mapSlaDetailsToViewModel = (slaDetails: ISlaDetails): ISlaDetailsViewModel => {
  const slaDetailsViewModel: ISlaDetailsViewModel = {
    slaTimes: slaDetails.slaTimes,
    slaDefaultTime: slaDetails.slaDefaultTime,
    lastModifiedBy: slaDetails.lastModifiedBy ? slaDetails.lastModifiedBy! : undefined,
    lastModifiedTimestamp: slaDetails.lastModifiedTimestamp ? new Date(slaDetails.lastModifiedTimestamp!) : undefined,
    dwhStartTime: new Date(slaDetails.dwhStartTime),
    dwhEndTime: new Date(slaDetails.dwhEndTime),
    dwhLastModifiedBy: slaDetails.dwhLastModifiedBy,
    dwhLastModifiedTimestamp: slaDetails.dwhLastModifiedTimestamp ? new Date(slaDetails.dwhLastModifiedTimestamp!) : undefined
  };

  return slaDetailsViewModel;
};

export { mapSlaDetailsToViewModel };
